import {prepareExportImage, withImageTimeout} from './exportImageQuality';

export default {
  methods: {
    async loadExportSlideImage(projectId, slide, index, loadingMode, imageQuality) {
      // Fetch the original in every mode. Resizing on the server can crop or
      // upscale, and OFFLINE has no server resize. Leave thumbnail consumers alone.
      const original = await withImageTimeout(this.loadThumbnailNew(projectId, slide, index, {loadingMode}));
      if (!original) throw new Error('No slide image found');
      return prepareExportImage(original, imageQuality);
    },
  },
};
